// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VtmfFilingJob } from './vtmf-filing-job';
import {
    VtmfFilingJobFromJSON,
    VtmfFilingJobFromJSONTyped,
    VtmfFilingJobToJSON,
    VtmfFilingJobToJSONTyped,
} from './vtmf-filing-job';

/**
 * 
 * @export
 * @interface VtmfFilingsResponse
 */
export interface VtmfFilingsResponse {
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingsResponse
     */
    dta_id: string;
    /**
     * 
     * @type {Array<VtmfFilingJob>}
     * @memberof VtmfFilingsResponse
     */
    filings: Array<VtmfFilingJob>;
    /**
     * 
     * @type {number}
     * @memberof VtmfFilingsResponse
     */
    total: number;
}

/**
 * Check if a given object implements the VtmfFilingsResponse interface.
 */
export function instanceOfVtmfFilingsResponse(value: object): value is VtmfFilingsResponse {
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('filings' in value) || value['filings'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function VtmfFilingsResponseFromJSON(json: any): VtmfFilingsResponse {
    return VtmfFilingsResponseFromJSONTyped(json, false);
}

export function VtmfFilingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VtmfFilingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dta_id': json['dta_id'],
        'filings': ((json['filings'] as Array<any>).map(VtmfFilingJobFromJSON)),
        'total': json['total'],
    };
}

export function VtmfFilingsResponseToJSON(json: any): VtmfFilingsResponse {
    return VtmfFilingsResponseToJSONTyped(json, false);
}

export function VtmfFilingsResponseToJSONTyped(value?: VtmfFilingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dta_id': value['dta_id'],
        'filings': ((value['filings'] as Array<any>).map(VtmfFilingJobToJSON)),
        'total': value['total'],
    };
}
